import React from 'react'
import Nav from '../Components/Nav'
import Footer from '../Components/Footer'
import NewsMain from '../Components/NewsMain'
import { recentPost, postDetails} from "../Components/Lists/newsAi"
import GoToTop from '../Components/GoToTop'

const NewsAi = () => {
  return (
    <>
    <Nav/>
    <NewsMain recentPost={recentPost} postDetails={postDetails}/>
    <Footer/>
    <GoToTop/>
    </>
  )
}

export default NewsAi